import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDepartment } from './interfaces';

export const getDepartmentList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDepartment[]>('/calculatorTariff/department/list', data)
    .then((response) => response.data);
};

export const getDepartmentAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/calculatorTariff/department/availableColumns')
    .then((response) => response.data);
};

export const getDepartmentAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/calculatorTariff/department/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDepartment = (departmentId: number) => {
  return instance()
    .get<IDepartment>('/calculatorTariff/department/load/' + departmentId)
    .then((response) => response.data);
};

export const createDepartment = (department: IDepartment) => {
  return instance()
    .post<IDepartment>('/calculatorTariff/department/save', department)
    .then((response) => response.data);
};

export const updateDepartment = (department: IDepartment) => {
  return instance()
    .post<IDepartment>(`/calculatorTariff/department/${department.departmentId}/update`, department)
    .then((response) => response.data);
};

export const deleteDepartment = (departmentId: number) => {
  return instance()
    .post('/calculatorTariff/department/archive', { departmentId })
    .then((response) => response.data);
};

export const recoverDepartment = (departmentId: number) => {
  return instance()
    .post('/calculatorTariff/department/recover', { departmentId })
    .then((response) => response.data);
};
